import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, input, OnChanges, SimpleChanges, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle, NgbModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FaBusinessIconsNotSolid } from 'app/shared/fa-business-area-icons/fa-business-icons-not-solid';
import { SharedModule } from 'app/shared/shared.module';
import { BaseNotificationWidget } from '../base-notification-widget';
import { ResizableWidgetComponent } from '../resizable-widget/resizable-widget.component';

@Component({
    selector: 'pcg-resizable-messages-widget',
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        NgbDropdown,
        NgbDropdownToggle,
        NgbDropdownMenu,
        NgbTooltip,
        FontAwesomeModule,
        SharedModule,

        ResizableWidgetComponent
    ],
    templateUrl: './resizable-messages-widget.html',
    styleUrls: ['./resizable-messages-widget.scss', '../resizable-widget/resizable-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResizableMessagesWidget extends BaseNotificationWidget {

    readonly baService = inject(FaBusinessIconsNotSolid);

    override PAGE_SIZE = 30;

    /** Tracks the loading state exposed to the template spinner. */
    readonly isLoading = computed(() => this.notificationsService.loading());

    ngOnInit() { this.initNotifications(); }
}
